import React from 'react'
import css from '../Assets/iconSkills/css-s.png';
import html from '../Assets/iconSkills/html-s.png';
import js from '../Assets/iconSkills/js-s.png';
import react from '../Assets/iconSkills/react-s.png';
import fire from '../Assets/iconSkills/fire-s.png';
import figma from '../Assets/iconSkills/figma-s.png';
import trello from '../Assets/iconSkills/trello-s.png'
import jest from '../Assets/iconSkills/jest-s.png';
import dx from '../Assets/iconSkills/xd-s.png';
import pega from '../Assets/iconSkills/pega-s.png';
import mx from '../Assets/iconSkills/mx-s.png';
import github from '../Assets/iconSkills/git-s.png';
import slack from '../Assets/iconSkills/slack-s.png';
import git from '../Assets/iconSkills/git-ss.png';
import '../pages/Skills.css';

const TechnicalSkills = () => {
  return (
    <div className='tec-div'>
          <h1 className='skill'>Technical Skills</h1>
    <div className='container-icon'>
  
     <div className='container-single'> <img src={css} alt="icon" className='icon' />  Css </div> 
       <div className='container-single'> <img src={html} alt="icon" className='icon' /> Html </div> 
       <div className='container-single'> <img src={js} alt="icon" className='icon' /> Javascript </div> 
       <div className='container-single'> <img src={react} alt="icon" className='icon' /> React </div> 
      <div className='container-single'>  <img src={fire} alt="icon" className='icon' /> Firebase </div> 
       <div className='container-single'> <img src={figma} alt="icon" className='icon' /> Figma </div> 
      <div className='container-single'>  <img src={trello} alt="icon" className='icon' /> Trello </div> 
      <div className='container-single'>  <img src={jest} alt="icon" className='icon' /> Jest </div> 
       <div className='container-single'> <img src={dx} alt="icon" className='icon' /> Adobe XD</div> 
       <div className='container-single'> <img src={pega} alt="icon" className='icon' /> Pega </div> 
       <div className='container-single'> <img src={mx} alt="icon" className='icon' /> Mendix </div> 
      <div className='container-single'>  <img src={github} alt="icon" className='icon' /> Github</div> 
      <div className='container-single'>  <img src={slack} alt="icon" className='icon' />  slack </div> 
      <div className='container-single'>  <img src={git} alt="icon" className='icon' />  Git</div> 
    </div></div>
  )
}

export default TechnicalSkills
